// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// sudo-switch-user imports
import { IContainer, IProps, IState } from "./SudoSwitchUser.d";
import { sudoSwitchUserFragments } from "./SudoSwitchUser.gql";
import { styles } from "./SudoSwitchUser.styles";
import { styles as sudoStyles } from "@components/sudo-wrapper/SudoWrapper.styles";

// state
import { IReduxState } from "@reducers/root.reducer";

// util
import { sudoSwitchUser } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { doSudoLogin } from "@util/auth.util";
import { windowLocation } from "@util/location.util";

// material-ui
import { Button, LinearProgress, Paper, TextField } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class SudoSwitchUserCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
      email: "",
    };
  }

  public handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      email: e.target.value,
    });
  };

  private onClick = () => {
    const email = this.state.email.trim();
    if (!email) {
      return;
    }

    this.setState({ loading: true });

    sudoSwitchUser(
      this.props.relay.environment,
      { email, jwtType: "Full" },
      () => this.onSwitchSuccess(),
      () => this.onSwitchFailure(),
    );
  };

  private onSwitchSuccess = () => {
    this.setState({ loading: false });
    this.showMessage(`Success, switching to: ${this.state.email}`);
    doSudoLogin();
    setTimeout(() => {
      // hard reload the page to /
      windowLocation.assign("SudoSwitchUserSuccess", "/app");
    }, 500);
  };

  private onSwitchFailure = () => {
    this.setState({ loading: false });
    this.showMessage(`Failed to switch users.`);
  };

  private showMessage(message: string) {
    this.props.snackBarOpen(message);
  }

  public render() {
    return (
      <Paper elevation={2} style={sudoStyles.paper}>
        <div style={sudoStyles.title}>Switch User</div>
        <div style={sudoStyles.row}>
          <TextField
            label="Email Address"
            onChange={this.handleEmailChange}
            value={this.state.email}
          />
        </div>
        <div style={sudoStyles.row}>
          <Button
            variant="contained"
            color="primary"
            style={sudoStyles.btn}
            onClick={() => this.onClick()}
            disabled={this.state.loading}
          >
            Switch User
          </Button>
        </div>
        {this.state.loading ? <LinearProgress variant="indeterminate" /> : null}
      </Paper>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const SudoSwitchUserStyled = withStyles(styles)(SudoSwitchUserCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SudoSwitchUserRedux = connect(mapStateToProps, {
  snackBarOpen,
})(SudoSwitchUserStyled);

///////////
// Relay //
///////////
export const SudoSwitchUser = createFragmentContainer<IContainer>(
  SudoSwitchUserRedux,
  sudoSwitchUserFragments,
);
